/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
import Container from "../components/container";
import PropTypes from "prop-types";
import SEO from "../components/seo";
import ProductSEO from "../components/product/product-seo";
import Image from "../components/image.js";
import styled from "styled-components";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/global-context-provider";
import { parsePrice, updateDataLayer } from "../utils/helpers";
import Breadcrumbs from "../components/breadcrumbs";
import Modal from "../components/modal";
import { _ } from "../utils/i18n";
import HeroCarousel from "../components/hero-carousel";
import ImagePagination from "../components/imagepagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faPlus,
  faMinus,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import ProductBlock from "../components/product-block";
import { ExpandCollapse } from "../components/expandcollapse";
import ProductHeart from "../components/product/product-heart";
import { modifyColor } from "../utils/helpers";
import MiniCart from "./../components/minicart";
import Button from "../components/button";
import Cf7SendRequest from "../components/cf7-send-request";
import ProductPrice from "../components/product/product-price";

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: repeat(2, 50%);
  width: 100%;
  gap: 1.25rem;
  margin: 0 0 2rem 0;
  background-color: var(--color-body);
  padding-block: 1rem 2rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-rows: repeat(1, auto);
    grid-template-columns: repeat(1, auto);
    margin: 0;
  }
`;
const RightDiv = styled.div`
  grid-area: 1 / 2 / 3 / 3;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 95%;
  margin-left: 1rem;
  padding: 2.5rem;
  background: var(--color-white);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
    grid-area: 3;
    margin-left: 0;
    padding: 1rem;
  }
`;

const Line = styled.div`
  height: 0;
  border: 1px solid #e8e8e8;
  width: 100%;
  margin-block: 1rem;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

const SaleBanner = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  background-color: red;
  color: white;
  width: 80px;
  text-align: center;
  padding: 5px;
  text-transform: uppercase;
  font-weight: 600;
`;

const Title = styled.h1`
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 700 !important;
  font-size: 25px;
  letter-spacing: 1px;
  line-height: 1.5;
  width: 100%;
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    font-size: 18px;
  }
`;

const Category = styled.p`
  font-size: 0.8rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: bold;
  text-transform: uppercase;
`;

const Stock = styled.p`
  margin-block: 0;
  font-style: italic;
  font-size: 0.7rem;
`;
const ArticleNo = styled.p`
  margin: 0;
`;
const AttributesDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  p {
    width: auto;
    text-transform: capitalize;
  }
`;
const AttributeLabel = styled.p`
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 1rem;
`;
const AttributeSelection = styled.div`
  & [type="radio"] {
    display: none;
  }
`;
const AttributeRadio = styled.input`
  &:checked + label,
  &:not(:checked) + label {
    position: relative;
    display: inline-block;
    padding: 10px 15px;
    font-size: 0.8rem;
    margin: 0 auto;
    margin-right: 5px;
    margin-bottom: 10px;
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    transition: all 0.3s ease-in-out;
    color: var(--color-primary);
    background-color: var(--color-secondary);
    border: 1px solid var(--color-primary);
    border-radius: var(--border-radius);
    @media (hover: hover) {
      &:hover {
        background-color: var(--color-primary);
        color: var(--color-white);
      }
    }
  }
  &:checked + label {
    background-color: var(--color-primary);
    color: var(--color-white);
  }
  &:disabled + label {
    opacity: 0.4;
    cursor: default;
    pointer-events: none;
  }
`;

const VariationDiv = styled.div`
  margin: 1rem 0;
`;

const StyledButton = styled.button`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $color }) => $color};
  font-family: var(--font-links);
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 1rem;
  border-radius: var(--border-radius);
  border: ${({ $border }) => $border};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  padding: 0.9375rem 2.5rem;
  min-width: 200px;
  @media (hover: hover) {
    &:hover {
      background-color: ${({ $hoverBackgroundColor }) =>
        $hoverBackgroundColor === "cart"
          ? modifyColor(`var(--color-primary)`, -40)
          : modifyColor(`var(--color-primary)`, 120)};
    }
  }
  &:disabled {
    background-color: ${({ $disabledBackgroundColor }) =>
      $disabledBackgroundColor === "cart"
        ? modifyColor(`var(--color-primary)`, 60)
        : modifyColor(`var(--color-primary)`, 180)};
    cursor: not-allowed;
  }
`;

const ThumbnailsWrapper = styled.div`
  grid-area: 2 / 1 / 3 / 2;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    display: flex;
    overflow-y: scroll;
    -ms-overflow-style: none; /* Hide scroll in IE and Edge */
    scrollbar-width: none; /* Hide scroll in Firefox */

    &::-webkit-scrollbar {
      display: none; /* Hide scrollbar for Chrome, Safari and Opera */
    }
  }
`;
const HeroCarouselWrapper = styled.div`
  grid-area: 1 / 1 / 2 / 2;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    grid-area: 1;
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: var(--color-accent1);
`;

const QuantityButton = styled.button`
  width: auto;
  height: 3.3rem;
  padding-inline: 1rem;
  background: var(--color-white);
  border-radius: 10px;
`;

const RelatedProducts = styled.div`
  display: grid;
  font-size: 1.25rem;
  grid-template-rows: repeat(1, auto);
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  overflow-x: auto;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: start;
  }
`;

const AccordionTitle = styled.h4`
  font-family: var(--font-paragraphs);
  font-size: 1.1rem;
`;

const AccordionContent = styled.div`
  width: 100%;
`;

const AccordionWrapper = styled.div`
  width: 100%;
  box-shadow: var(--box-shadow);
  background-color: var(--color-white);
  border-radius: var(--border-radius);
  padding-inline: 2rem;
  margin: 0 0 2rem 0;
  h3 {
    margin: 0;
    padding: 2rem 0 0 0;
    font-size: 1.25rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      padding: 2rem 0 1rem 0;
    }
  }

  & div:last-of-type {
    border-bottom: none !important;
  }
`;

const InputNumberWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #dfdfdf;
  border-radius: var(--border-radius);

  input {
    width: 30px;
    height: 48px;
    border: none;
    text-align: center;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin-bottom: 2rem;
`;
const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: var(--color-body);
  }
`;
const TableCell = styled.td`
  padding: 0.4rem 2.5rem;
  width: 50%
  word-wrap: break-word;

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 0.2rem;
    font-size: 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TopInCartModal = styled.div`
  background-color: var(--color-body);
  color: var(--color-black);
  height: 5.5rem;
  display: flex;
  align-items: center;
  padding-inline: 2rem;
  margin-bottom: 1rem;
`;

const ProductPDFWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  overflow: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 0.2rem;
    > a {
      padding: 0.5rem 1rem;
      font-size: 0.8rem;
    }
  }
`;

const DeliveryTime = styled.p`
  margin-block: 0.5rem 0;
  font-size: 0.8rem;
  padding-left: 0.1rem;
  font-weight: bold;
`;

const LoadingIcon = styled(FontAwesomeIcon)`
  font-size: 1.3rem;
  color: var(--color-white);
  opacity: 0.5;
`;
const ProductCount = styled.span`
  font-weight: 500;
  font-size: 1rem;
  color: rgba(54, 54, 54, 0.6);
`;

const Product = ({ data: { wpProduct, wp, wpProductCategory } }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const [product, setProduct] = useState(wpProduct);
  const relatedProducts =
    product?.upsell?.nodes?.length > 0
      ? product?.upsell?.nodes
      : product?.crossSell?.nodes;
  const dispatch = useContext(GlobalDispatchContext);
  const [nrOfItems, setNrOfItems] = useState(1);
  const [galleryImages] = useState(() => {
    const updatedGalleryImages = [...product.galleryImages.nodes];
    if (product.variations) {
      updatedGalleryImages.unshift(product.image);
      product.variations.nodes.forEach((variation) => {
        if (variation.image.databaseId != product.image.databaseId) {
          updatedGalleryImages.push(variation.image);
        }
      });
    } else {
      updatedGalleryImages.unshift(product.image);
    }
    const uniqueDatabaseIds = new Set();
    const filteredImages = [];
    updatedGalleryImages.forEach((image) => {
      const url = image.mediaItemUrl ? image.mediaItemUrl : image.sourceUrl;
      if (!uniqueDatabaseIds.has(url)) {
        uniqueDatabaseIds.add(url);
        filteredImages.push(image);
      }
    });
    return filteredImages;
  });

  const [variationAttributes] = useState(() =>
    product?.attributes?.nodes
      .filter((attribute) => attribute.variation)
      .map((attribute) => {
        //Get the name from the variation attribute because it's the attributeName that the cart wants
        const name = product?.variations?.nodes.reduce(
          (attributeName, variation) => {
            if (attributeName) {
              return attributeName;
            }
            return variation.attributes.nodes.find(
              (variationAttribute) =>
                !variationAttribute.label.localeCompare(
                  attribute.label.replace(/ /g, "-"),
                  "en",
                  { sensitivity: "base" }
                )
            )?.name;
          },
          undefined
        );
        const options =
          attribute.terms?.nodes.map((term) => ({
            name: term.slug,
            label: term.name,
          })) ||
          attribute.options.map((option) => ({ name: option, label: option }));
        return { name, label: attribute.label, options };
      })
  );
  const [selectedAttributes, setSelectedAttributes] = useState(() => {
    const initialState = {};
    variationAttributes?.forEach((variationAttribute) => {
      initialState[variationAttribute.name] =
        variationAttribute.options[0]?.name;
    });
    return initialState;
  });
  const [isReadyToShop, setIsReadyToShop] = useState(
    variationAttributes?.length > 0 ? false : true
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const filteredProducts = product?.variations?.nodes.filter(
      (variation) =>
        variation.attributes === null ||
        variation?.attributes?.nodes?.every(
          (attribute) =>
            attribute?.option === null ||
            attribute?.option === selectedAttributes[attribute?.name]
        )
    );

    setProduct({ ...product, ...(filteredProducts?.[0] || {}) });
    if (index !== undefined) {
      setIndex(
        handleThumbnailIndex({ ...product, ...(filteredProducts?.[0] || {}) })
      );
    }
    if (filteredProducts) {
      const isReadyToShop = Object.values(selectedAttributes).every(
        (option) => option !== undefined
      );
      setIsReadyToShop(isReadyToShop);
    }
  }, [selectedAttributes]);

  const findMatchingVariation = (product) => {
    const { attributes } = product;
    if (product.variations) {
      for (const variation of product.variations.nodes) {
        const matchingAttributes = attributes?.nodes?.every((attr) => {
          return variation?.attributes?.nodes?.some((variationAttr) => {
            return (
              variationAttr.name === attr.name &&
              variationAttr.value === attr.value
            );
          });
        });
        if (matchingAttributes) {
          return variation;
        }
      }
    }
    return null;
  };

  const handleThumbnailIndex = (updatedProduct) => {
    const selectedVariation = findMatchingVariation(updatedProduct);
    const index = galleryImages.findIndex((item) => {
      return JSON.stringify(item) === JSON.stringify(selectedVariation?.image);
    });
    if (index !== -1) {
      return index;
    } else {
      return 0;
    }
  };
  const toggleAttribute = (productAttribute, option) => {
    setSelectedAttributes({
      ...selectedAttributes,
      [productAttribute.name]:
        selectedAttributes[productAttribute.name] === option.name
          ? undefined
          : option.name,
    });
  };
  const productObject = {
    name: product?.name,
    priceRaw:
      product.price &&
      parsePrice(
        product.price,
        wp.wcSettings.priceThousandSeparator,
        wp.wcSettings.priceDecimalSeparator
      ),
    price: product.price,
    salePrice: product.salePrice,
    regularPrice: product.regularPrice,
    onSale: product.onSale,
    sku: product.sku ?? "",
    quantity: nrOfItems > 1 ? nrOfItems : 1,
    id: product.databaseId,
    image: product.image,
    uri: product.uri,
    currency: wp.wcSettings.currency,
    category: product.productCategories?.nodes?.[0]?.name,
    brand: product.productBrands?.nodes?.[0]?.name,
    attributes: selectedAttributes ? selectedAttributes : undefined,
    attributeLabels: variationAttributes
      ? variationAttributes?.map((attribute) => ({
          label: attribute.label,
          value: attribute.options.find(
            (option) => option.name === selectedAttributes[attribute.name]
          )?.label,
        }))
      : product?.crbSimpleProductAttributeName
      ? {
          label: product.crbSimpleProductAttributeName,
          value: product.crbSimpleProductAttributeValue,
        }
      : undefined,
  };
  const [index, setIndex] = useState();
  const { cart } = useContext(GlobalStateContext);
  const [totalQtyOfProducts, setTotalQtyOfProducts] = React.useState(0);

  useEffect(() => {
    setTotalQtyOfProducts(
      cart.reduce((totalQtyOfProducts, item) => {
        return totalQtyOfProducts + item.quantity;
      }, 0)
    );
  }, [cart]);

  useEffect(() => {
    updateDataLayer(async () =>
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: productObject.currency,
          value: productObject.priceRaw,
          items: [
            {
              item_id: productObject.id,
              item_name: productObject.name,
              item_category: productObject.category,
              item_brand: productObject.brand,
              price: productObject.priceRaw,
              quantity: 1,
            },
          ],
        },
      })
    );
  }, []);

  const onAddToCartClick = () => {
    setIsLoading(true);
    dispatch({
      type: "ADD_TO_CART",
      value: productObject,
    });
    setTimeout(() => {
      setIsLoading(false);
      setCartModalOpen(true);
    }, 2000);

    updateDataLayer(async () =>
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: productObject.currency,
          value:
            nrOfItems > 1
              ? nrOfItems * productObject.priceRaw
              : productObject.priceRaw,
          items: [
            {
              item_id: productObject.id,
              item_name: productObject.name,
              item_category: productObject.category,
              item_brand: productObject.brand,
              price: productObject.priceRaw,
              quantity: nrOfItems > 1 ? nrOfItems : 1,
            },
          ],
        },
      })
    );
  };

  const isBusinessProduct = product.productCategories.nodes.some(
    (node) =>
      node.crbMasterCategoryBusiness === true ||
      node.wpParent?.node?.crbMasterCategoryBusiness === true
  );

  // Some category url had the WP url in the breadcrumbs, this help function fixes it.
  function modifyBreadcrumbs(breadcrumbs) {
    return breadcrumbs.map((breadcrumb) => {
      if (breadcrumb.url.includes(process.env.GATSBY_WORDPRESS_URL)) {
        breadcrumb.url = breadcrumb.url.replace(
          process.env.GATSBY_WORDPRESS_URL,
          process.env.GATSBY_SITE_URL
        );
      }
      return breadcrumb;
    });
  }

  useEffect(() => {
    setIndex(0);
  }, []);

  return (
    <Layout>
      <Container disableAnimation disableMargin maxWidth="lg">
        <Breadcrumbs
          breadcrumbList={modifyBreadcrumbs(product?.seo.breadcrumbs)}
        />
      </Container>
      {index !== undefined && (
        <>
          <Container maxWidth="lg" disableMargin disableAnimation>
            <Wrapper>
              {galleryImages?.length > 0 ? (
                <>
                  <HeroCarouselWrapper>
                    <HeroCarousel
                      index={index}
                      mediaItems={galleryImages}
                      onChangeIndex={(index) => setIndex(index)}
                      objectFit="contain"
                      showPagination={false}
                      infiniteLoop={false}
                    />
                  </HeroCarouselWrapper>
                  <ThumbnailsWrapper>
                    <ImagePagination
                      onChangeIndex={(index) => setIndex(index)}
                      images={galleryImages}
                      index={index}
                    />
                  </ThumbnailsWrapper>
                </>
              ) : (
                <ImageWrapper>
                  {product?.image && <Image image={product.image} />}
                  {product?.onSale && <SaleBanner>Sale</SaleBanner>}
                </ImageWrapper>
              )}
              <RightDiv>
                {product?.productBrands?.nodes.length > 0 &&
                  product?.productBrands?.nodes.map((brand, index) => (
                    <Category key={index}>{brand.name}</Category>
                  ))}
                <Line />
                <Title>{product?.name}</Title>
                {product?.sku && <ArticleNo>Art.Nr: {product?.sku}</ArticleNo>}
                {product?.shortDescription && (
                  <>
                    <Line />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: product?.shortDescription,
                      }}
                    />
                    <Line />
                  </>
                )}
                {isBusinessProduct === false && (
                  <React.Fragment>
                    {product?.price && (
                      <ProductPrice
                        product={product}
                        align="left"
                        customFontSize={18}
                        customSaleFontSize={24}
                        saleColor="accent1"
                      />
                    )}
                    {product?.stockStatus === "IN_STOCK" ? (
                      <Stock>{_("På lager")}</Stock>
                    ) : (
                      <Stock>{_("Ikke på lager")}</Stock>
                    )}
                  </React.Fragment>
                )}

                {product?.productCategories?.nodes?.[0]
                  ?.crbPurchaseConditions && (
                  <div>
                    {product?.productCategories?.nodes?.[0]?.crbPurchaseConditions.map(
                      (condition, index) => (
                        <div key={index}>
                          <StyledIcon
                            style={{ marginRight: "0.5rem", color: "#EA1A2A" }}
                            icon={faCheck}
                          />
                          {condition.text}
                        </div>
                      )
                    )}
                  </div>
                )}

                {product?.crbSimpleProductAttributeName && (
                  <AttributesDiv>
                    <p>
                      <span style={{ fontWeight: "bold" }}>
                        {product.crbSimpleProductAttributeName}
                      </span>
                      : {product.crbSimpleProductAttributeValue}
                    </p>
                  </AttributesDiv>
                )}
                <VariationDiv>
                  {variationAttributes?.map((productAttribute, i) => {
                    return (
                      <AttributeSelection key={i}>
                        <AttributeLabel>
                          {productAttribute.label}
                        </AttributeLabel>
                        {productAttribute.options.map((option, i) => (
                          <React.Fragment key={i}>
                            <AttributeRadio
                              type="radio"
                              name={productAttribute.name}
                              id={option.name}
                              onChange={() =>
                                toggleAttribute(productAttribute, option)
                              }
                              checked={
                                selectedAttributes[productAttribute.name] ===
                                option.name
                              }
                              disabled={product?.variations?.nodes?.reduce(
                                (isOptionDisabled, variation) => {
                                  return (
                                    isOptionDisabled &&
                                    variation?.attributes.nodes.reduce(
                                      (
                                        isOptionDisabled,
                                        variationAttribute
                                      ) => {
                                        if (
                                          variationAttribute?.option === null
                                        ) {
                                          return isOptionDisabled;
                                        }
                                        if (
                                          variationAttribute?.name ===
                                          productAttribute?.name
                                        ) {
                                          if (
                                            variationAttribute?.option ===
                                            option?.name
                                          ) {
                                            return isOptionDisabled;
                                          }
                                        } else {
                                          if (
                                            selectedAttributes[
                                              variationAttribute?.name
                                            ] === undefined
                                          ) {
                                            return isOptionDisabled;
                                          }
                                          if (
                                            selectedAttributes[
                                              variationAttribute?.name
                                            ] === variationAttribute?.option
                                          ) {
                                            return isOptionDisabled;
                                          }
                                        }
                                        return true;
                                      },
                                      false
                                    )
                                  );
                                },
                                true
                              )}
                            />
                            <label htmlFor={option.name}>{option.label}</label>
                          </React.Fragment>
                        ))}
                      </AttributeSelection>
                    );
                  })}
                </VariationDiv>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    flexWrap: "wrap",
                  }}
                >
                  {product?.crbBuyOrSendRequest?.value === "purchase" ? (
                    <>
                      <InputNumberWrapper>
                        <QuantityButton
                          onClick={() =>
                            nrOfItems > 1 && setNrOfItems(nrOfItems - 1)
                          }
                        >
                          <FontAwesomeIcon icon={faMinus} size="xs" />
                        </QuantityButton>

                        <input
                          min="1"
                          type="number"
                          value={nrOfItems}
                          onChange={(e) =>
                            setNrOfItems(parseInt(e.target.value))
                          }
                        />
                        <QuantityButton
                          onClick={() => setNrOfItems(nrOfItems + 1)}
                        >
                          <FontAwesomeIcon icon={faPlus} size="xs" />
                        </QuantityButton>
                      </InputNumberWrapper>
                      <StyledButton
                        $hoverBackgroundColor="cart"
                        $disabledBackgroundColor="cart"
                        $border="none"
                        $color="var(--color-white)"
                        $backgroundColor="var(--color-primary)"
                        disabled={!isReadyToShop}
                        onClick={onAddToCartClick}
                      >
                        {isLoading ? (
                          <LoadingIcon
                            icon={faSpinner}
                            className="fa-spin"
                          ></LoadingIcon>
                        ) : (
                          _("Legg i handlekurv")
                        )}
                      </StyledButton>
                    </>
                  ) : (
                    <StyledButton
                      $border="1px solid var(--color-primary)"
                      $color="var(--color-primary)"
                      $backgroundColor="var(--color-white)"
                      onClick={() => setModalOpen(true)}
                    >
                      {_("Send forespørsel")}
                    </StyledButton>
                  )}
                  <ProductHeart
                    product={product}
                    size="large"
                    currency={wp.wcSettings.currency}
                    priceRaw={
                      product?.price &&
                      parsePrice(
                        product.price,
                        wp.wcSettings.priceThousandSeparator,
                        wp.wcSettings.priceDecimalSeparator
                      )
                    }
                  />
                </div>

                {product?.crbBuyOrSendRequest?.value === "purchase" ? (
                  <div
                    style={{ marginTop: "1rem" }}
                    dangerouslySetInnerHTML={{
                      __html: wp?.crbThemeOptions?.crbKlarnaExplanation,
                    }}
                  />
                ) : (
                  <div
                    style={{ marginTop: "1rem" }}
                    dangerouslySetInnerHTML={{
                      __html: wp?.crbThemeOptions?.crbSendRequestExplanation,
                    }}
                  />
                )}
                {product?.crbDeliveryTime && (
                  <DeliveryTime>
                    {_("Levering ")}
                    {product?.crbDeliveryTime}
                  </DeliveryTime>
                )}
              </RightDiv>
            </Wrapper>
            <AccordionWrapper>
              {wpProduct?.description && (
                <>
                  <h3>{_("Om produktet")}</h3>
                  <ExpandCollapse>
                    <AccordionTitle>{_("Produktbeskrivelse")}</AccordionTitle>
                    <AccordionContent
                      dangerouslySetInnerHTML={{
                        __html: wpProduct.description,
                      }}
                    />
                  </ExpandCollapse>
                </>
              )}
              {product?.crbProductSpecifications.length > 0 && (
                <ExpandCollapse>
                  <AccordionTitle>{_("Spesifikasjoner")}</AccordionTitle>
                  <Table>
                    {product?.crbProductSpecifications?.map((spec, i) => (
                      <TableRow key={i}>
                        <TableCell>{spec?.title}</TableCell>
                        <TableCell style={{ textAlign: "right" }}>
                          {spec?.text}
                        </TableCell>
                      </TableRow>
                    ))}
                  </Table>
                </ExpandCollapse>
              )}
              {product?.crbProductAdditionalInfo.length > 0 &&
                product?.crbProductAdditionalInfo?.map((info, i) => (
                  <ExpandCollapse key={i}>
                    <AccordionTitle>{info.title}</AccordionTitle>
                    <AccordionContent
                      dangerouslySetInnerHTML={{
                        __html: info.text,
                      }}
                    />
                  </ExpandCollapse>
                ))}
              {product?.crbProductPdf.length > 0 && (
                <ExpandCollapse>
                  <AccordionTitle>{_("Datablad")}</AccordionTitle>
                  <ProductPDFWrapper>
                    {product?.crbProductPdf?.map((pdf, i) => (
                      <Button
                        variant={"outlined"}
                        target={"_blank"}
                        url={`${process.env.GATSBY_WORDPRESS_URL}/${pdf.uri}`}
                        key={i}
                      >
                        {pdf.title}
                      </Button>
                    ))}
                  </ProductPDFWrapper>
                </ExpandCollapse>
              )}
            </AccordionWrapper>
            {relatedProducts?.length > 0 && (
              <Container
                maxWidth="lg"
                alignContent="flex-start"
                disableAnimation
                disableGutters
              >
                <h2 style={{ fontSize: "1.25em", marginBottom: "0.875rem" }}>
                  {_("Relaterte produkter")}
                </h2>
                <RelatedProducts className="related-products">
                  {relatedProducts?.map((product, i) => {
                    return (
                      <ProductBlock
                        key={i}
                        product={product}
                        showTitle
                        showBrand
                        showPriceModified
                        scrollHorizontalOnMobile
                      />
                    );
                  })}
                </RelatedProducts>
              </Container>
            )}

            <p>
              {isBusinessProduct ? (
                <Link to="/produkter-bedrift/">
                  {_("Tilbake til produkter")}
                </Link>
              ) : (
                <Link to={wpProductCategory?.uri}>
                  {_("Tilbake til nettbutikken")}
                </Link>
              )}
            </p>
          </Container>
          <Modal
            isOpen={modalOpen}
            animateFrom="top"
            variant="big"
            onClose={() => setModalOpen(false)}
          >
            <Cf7SendRequest
              product={wpProduct}
              id={wp.crbThemeOptions.crbContactForm?.id}
              html={wp.crbThemeOptions.crbContactForm?.rendered}
              action={
                process.env.GATSBY_WORDPRESS_URL +
                wp.crbThemeOptions.crbContactForm?.url
              }
            />
          </Modal>
          <Modal
            isOpen={cartModalOpen}
            animateFrom="right"
            variant="small"
            onClose={() => setCartModalOpen(false)}
          >
            {totalQtyOfProducts > 0 ? (
              <>
                <TopInCartModal>
                  <h1>
                    {_("Handlekurv")}
                    <ProductCount>{` (${totalQtyOfProducts})`}</ProductCount>
                  </h1>
                </TopInCartModal>
                <MiniCart onClose={() => setCartModalOpen(false)} />
              </>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <MiniCart onClose={() => setCartModalOpen(false)} />
              </div>
            )}
          </Modal>
        </>
      )}
    </Layout>
  );
};

Product.propTypes = {
  data: PropTypes.object,
};

export default Product;

export const Head = ({ data: { wpProduct } }) => (
  <>
    <ProductSEO product={wpProduct} description={wpProduct?.seo?.metaDesc} />
    <SEO
      breadcrumbs={[]}
      title={wpProduct?.name}
      image={wpProduct?.image?.sourceUrl}
      description={wpProduct?.seo?.metaDesc}
    />
  </>
);

export const query = graphql`
  query ($id: String!) {
    wpProductCategory(crbMasterCategory: { eq: true }) {
      uri
    }
    wpProduct(id: { eq: $id }) {
      ...ProductTypes
      name
      seo {
        title
        breadcrumbs {
          text
          url
        }
        metaDesc
      }
    }
    wp {
      wcSettings {
        currency
        priceDecimalSeparator
        priceThousandSeparator
      }
      crbThemeOptions {
        crbContactForm {
          formTemplate
          id
          url
          rendered
          title
          className
        }
        crbSendRequestExplanation
        crbKlarnaExplanation
      }
    }
  }
`;
